import React from "react";

class RunTimeDataType extends React.Component {
  render() {
    if (this.props.data != null) {
      return <div className={this.renderAlignment()}>{this.formatTime(this.props.data)}</div>;
    } else {
      return <em className="text-center">&nbsp;</em>;
    }
  }

  renderAlignment() {
    if (this.props.header && this.props.header.text_align === "left") {
      return "text-left";
    } else if (this.props.header && this.props.header.text_align === "center") {
      return "text-center";
    } else if (this.props.header && this.props.header.text_align === "right") {
      return "text-right";
    } else {
      return "";
    }
  }

  formatTime(totalSeconds) {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = Math.floor(totalSeconds % 60);
    const milliseconds = Math.round((totalSeconds - Math.floor(totalSeconds)) * 1000);

    return `${minutes}:${seconds.toString().padStart(2, '0')}.${milliseconds.toString().padStart(3, '0')}`;
  }
}

export default RunTimeDataType;
